import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const SectionTitle = ({ children }) => (
  <h2
    className="text-2xl md:text-3xl font-normal tracking-tight mb-6 mt-12"
    style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
  >
    {children}
  </h2>
);

const Item = ({ children }) => (
  <li className="text-base leading-relaxed pl-2" style={{ color: '#0F2942' }}>
    {children}
  </li>
);

const TermsPage = () => (
  <div className="min-h-screen" style={{ backgroundColor: '#F0EBE2' }}>
    <Navbar />
    <SEO
      title="Terms and Conditions"
      path="/terms"
      description="Terms and conditions for using CultureCareers, India's specialist recruitment platform for the creative industries."
    />
    <section className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
      <div className="max-w-3xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] font-medium mb-5" style={{ color: '#D4820A' }}>
          Legal
        </p>
        <h1
          className="text-4xl md:text-5xl font-normal tracking-tight mb-6"
          style={{ fontFamily: "'Playfair Display', serif", color: '#0F2942' }}
        >
          Terms and Conditions
        </h1>
        <div className="w-20 h-px mb-8" style={{ backgroundColor: 'rgba(212,130,10,0.6)' }} />
        <p className="text-base md:text-lg leading-relaxed" style={{ color: '#0F2942' }}>
          By using CultureCareers and submitting any form on this site, you agree to the terms below. These apply to anyone using the platform: creative professionals, event and festival crew, and hiring organisations.
        </p>

        <SectionTitle>For talent and crew</SectionTitle>
        <ul className="list-disc pl-5 space-y-3">
          <Item>You consent to CultureCareers collecting and storing your personal information, including your resume, portfolio and contact details, to match you with relevant opportunities.</Item>
          <Item>Your profile may be shared with employers, recruiters, or collaborators for the purpose of job and gig matching.</Item>
          <Item>CultureCareers does not guarantee job placement, interviews, or responses from employers. Registering with our network does not guarantee placement.</Item>
          <Item>You are responsible for ensuring that the information you provide is accurate and up to date.</Item>
          <Item>CultureCareers is not liable for any employment decisions, offers, or interactions between you and third parties.</Item>
          <Item>You may request removal of your data at any time by writing to partnerships@culturecareers.org.</Item>
        </ul>

        <SectionTitle>For employers</SectionTitle>
        <ul className="list-disc pl-5 space-y-3">
          <Item>CultureCareers provides a platform to publish opportunities and does not guarantee applications, hires, or outcomes.</Item>
          <Item>All listings are subject to review. We reserve the right to approve, reject, or remove any listing.</Item>
          <Item>You are responsible for the accuracy, authenticity, and legality of the information provided.</Item>
          <Item>Any payment made is for listing visibility and distribution, not for guaranteed results.</Item>
          <Item>CultureCareers is not liable for hiring decisions, candidate interactions, or employment outcomes.</Item>
          <Item>Payments are non-refundable once a listing has been published.</Item>
        </ul>

        <SectionTitle>Data and contact</SectionTitle>
        <p className="text-base leading-relaxed mb-4" style={{ color: '#0F2942' }}>
          We contact registrants only about relevant opportunities, unless you opt in to receive broader updates. We do not sell your information. All data is stored securely and treated as confidential.
        </p>
        <p className="text-base leading-relaxed" style={{ color: '#0F2942' }}>
          For any questions about these terms, or to request data removal, write to{' '}
          <a href="mailto:partnerships@culturecareers.org" className="underline" style={{ color: '#D4820A' }}>
            partnerships@culturecareers.org
          </a>.
        </p>
      </div>
    </section>
    <Footer />
  </div>
);

export default TermsPage;
